import { render, staticRenderFns } from "./areaList.vue?vue&type=template&id=153ac381&"
import script from "./areaList.vue?vue&type=script&lang=js&"
export * from "./areaList.vue?vue&type=script&lang=js&"
import style0 from "./areaList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports